module.exports = __webpack_public_path__ + "img/left-lightning6.fccb40c6.png";